import { Link } from "react-router-dom";
import { formatDuration, formatViews } from "@/utils/format";

interface ShortVideoCardProps {
  id: string;
  title: string;
  tag: string;
  duration: number;
  views: number;
  cover: string;
  uploadDate: string;
}

export default function ShortVideoCard({
  id,
  title,
  tag,
  duration,
  views,
  cover,
  uploadDate,
}: ShortVideoCardProps) {
  return (
    <article className="group">
      <Link to={`/detail/short-video/${id}`} className="block">
        <div className="relative aspect-video w-full overflow-hidden rounded-lg border border-background-800/80 bg-background-800">
          <img
            src={cover}
            alt={`${title} 短视频封面`}
            title={`${title} - 午夜视频精选短视频`}
            className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.06]"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background-950/85 via-background-950/10 to-transparent" />
          <span className="absolute left-3 top-3 rounded-md bg-background-950/70 px-2 py-1 text-[11px] text-secondary-200 backdrop-blur-sm">
            {tag}
          </span>
          <span className="absolute bottom-3 right-3 rounded-md bg-background-950/75 px-2 py-1 font-label text-[11px] tracking-wider text-foreground-100 backdrop-blur-sm">
            {formatDuration(duration)}
          </span>
          <span className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-accent-500 text-background-950">
              <i className="ri-play-fill text-xl" />
            </span>
          </span>
        </div>
        <h3 className="mt-3 line-clamp-2-safe text-sm font-medium leading-6 text-foreground-50 transition-colors group-hover:text-accent-400">
          {title}
        </h3>
        <p className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line text-xs" />
            {formatViews(views)}
          </span>
          <span className="h-2.5 w-px bg-background-700" />
          <span>{uploadDate.replaceAll("-", ".")}</span>
        </p>
      </Link>
    </article>
  );
}